/* ELIO Save for Later, REVIEW DRAFT ONLY. Depends on existing Omnisend form+event workflow.
   Does not change checkout, subscribe contacts itself or send email without form submission.
   Customer must agree to the existing form's marketing-consent wording. */
(function(){
  'use strict';
  if (window.__ELIO_SAVE_LATER_DRAFT__) return;
  window.__ELIO_SAVE_LATER_DRAFT__ = true;
  var formID = (window.ELIO_SAVE_CART_CONFIG && window.ELIO_SAVE_CART_CONFIG.formID) || '';
  if (!/^[a-f0-9]{24}$/.test(formID)) return;
  var pending = null;
  var didSubmit = false;
  var inFlight = false;
  var css = [
    '.elio-save-later__action{border:0;background:transparent;padding:9px 12px;display:flex;align-items:center;justify-content:center;gap:7px;cursor:pointer;font-family:Avenir,"Avenir Next",Arial,sans-serif;font-size:12px;font-weight:500;letter-spacing:.025em;text-decoration:underline;text-underline-offset:3px;transition:opacity .15s;line-height:1.4;}',
    '.elio-save-later__action:hover{opacity:.7}.elio-save-later__action:focus-visible{outline:2px solid currentColor;outline-offset:3px}.elio-save-later__action:disabled{opacity:.5;cursor:wait}',
    '.elio-save-later__action--pdp{display:flex!important;width:100%!important;max-width:100%!important;box-sizing:border-box!important;margin:7px 0 3px!important;padding:6px 0!important;min-height:32px;align-self:stretch!important;justify-self:stretch!important;justify-content:center!important;align-items:center!important;text-align:center!important;gap:7px!important;color:inherit!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;text-decoration:underline!important;position:relative;z-index:1;}',
    '.elio-save-later__action--drawer{color:#eae6de!important;min-height:38px;width:100%;margin-top:0;text-decoration:underline!important;}',
    '.elio-save-later__action--cart{color:#454545;min-height:38px;width:100%;margin:4px auto 0;}',
    '.elio-pdp__sticky-atc:not(.elio-flip-stack):has(>.elio-save-later__action--sticky){flex-wrap:wrap!important;row-gap:3px!important;}',
    '.elio-pdp__sticky-atc>.elio-save-later__action--sticky{flex-basis:100%;width:100%;min-height:28px;padding:3px 8px; font-size:11px;color:inherit;}',
    '.elio-flip__utilities{display:flex;gap:8px;width:100%;align-items:stretch}',
    '.elio-flip__utilities>.elio-flip__review{flex:1 1 50%;width:auto;min-width:0;margin:0;}',
    '.elio-flip__utilities>.elio-save-later__action--sticky{flex:1 1 50%;min-width:0;min-height:40px;padding:5px;font-size:10px;letter-spacing:.04em;text-transform:uppercase;white-space:nowrap;border:1px solid rgba(0,0,0,.23);color:inherit;text-decoration:none;}',
    '.elio-flip__utilities>.elio-save-later__action--sticky:hover{border-color:rgba(0,0,0,.5)}',
    '@media(min-width:768px){.elio-save-later__action--pdp{margin-top:7px!important}.elio-save-later__action--sticky{display:none!important}}'
  ];
  var style=document.createElement('style');
  style.setAttribute('data-elio-save-later-draft','');
  style.textContent=css.join('\n');
  document.head.appendChild(style);
  function safeImage(raw){
    if(typeof raw==='object'&&raw)raw=raw.url||raw.src||'';
    raw=String(raw||'');
    if(/^\/\//.test(raw))raw='https:'+raw;
    if(/^\//.test(raw))raw=location.origin+raw;
    return /^https:\/\//i.test(raw)?raw:'';
  }
  function link(items){
    var counts=Object.create(null),positions=Object.create(null),qty=0,lines=[];
    (items||[]).forEach(function(item){
      var id=String(item.variant_id||'');var n=Number(item.quantity||0);
      if(!/^\d+$/.test(id)||!Number.isSafeInteger(n)||n<1)return;
      counts[id]=(counts[id]||0)+n;qty+=n;
      if(positions[id]!==undefined){lines[positions[id]].quantity+=n;return;}
      var title=String(item.product_title||item.title||'ELIO brief').slice(0,160);
      var variant=String(item.variant_title||'');
      if(/^default title$/i.test(variant))variant='';
      var image=safeImage(item.featured_image||item.image||'');
      var line={title:title,variantTitle:variant.slice(0,100),quantity:n,imageUrl:image};
      positions[id]=lines.length;lines.push(line);
    });
    if(qty<1)return null;
    return {url:location.origin+'/cart/'+Object.keys(counts).map(function(k){return k+':'+counts[k]}).join(',')+'?storefront=true',qty:qty,lineItems:lines};
  }
  function selected(){
    var root=document.querySelector('.elio-pdp__form[data-elio-purchase-form]');
    var input=root&&root.querySelector('input[name="id"]');
    var atc=root&&root.querySelector('.elio-pdp__atc');
    if(!input||!atc||atc.disabled||root.hidden)return null;
    var id=String(input.value||''),qty=1;
    var q=root.querySelector('input[name="quantity"]');
    if(q && /^\d+$/.test(q.value))qty=Math.max(1,Math.min(12,Number(q.value)));
    if(!/^\d+$/.test(id))return null;
    var script=document.querySelector('[data-elio-save-product-json]');
    var p=null;
    try{p=script&&JSON.parse(script.textContent);}catch(e){}
    // Guard against a product switch that changed the selected variant without
    // updating the JSON. Never send a fabricated or mismatched cart item.
    var v=p&&p.variants&&p.variants.find(function(x){return String(x.id)===id});
    if(!v||v.available===false)return null;
    var image=(v.featured_image&&v.featured_image.src)||p.featured_image||(p.images&&p.images[0])||'';
    return link([{variant_id:id,quantity:qty,product_title:p.title,variant_title:v.public_title||v.title,featured_image:image}]);
  }
  function message(text){
    var toast=document.getElementById('elio-save-later-status');
    if(!toast){
      toast=document.createElement('div');toast.id='elio-save-later-status';
      toast.setAttribute('role','status');toast.setAttribute('aria-live','polite');
      toast.style.cssText='position:fixed;left:18px;right:18px;bottom:calc(18px + env(safe-area-inset-bottom));z-index:2147483600;background:#191617;color:#f1ede7;padding:14px 16px;font:13px/1.45 Avenir,Arial,sans-serif;text-align:center;box-shadow:0 8px 28px rgba(0,0,0,.22);max-width:480px;margin:0 auto';
      document.body.appendChild(toast);
    }
    toast.textContent=text;
    window.setTimeout(function(){if(toast.textContent===text)toast.remove()},4200);
  }
  var openRequest=0;
  var formSeen=false;
  function presentForm(state){
    if(!state){message('Select an available size, or add a brief to your cart first.');return;}
    pending=state;
    didSubmit=false;
    formSeen=false;
    var request=++openRequest;
    window.__ELIO_MANUAL_SAVE_INTENT__=true;
    window.omnisend=window.omnisend||[];
    try{
      window.omnisend.push(['openForm',formID]);
    }catch(e){
      pending=null;
      window.__ELIO_MANUAL_SAVE_INTENT__=false;
      message('The save form could not open. Your cart is unchanged.');
      return;
    }
    // A click must never silently do nothing, including in Shopify theme preview.
    window.setTimeout(function(){
      if(request!==openRequest||formSeen||!pending)return;
      pending=null;
      window.__ELIO_MANUAL_SAVE_INTENT__=false;
      message('The save form did not open. Please try again outside the theme editor.');
    },2500);
  }
  function open(source){
    if(inFlight)return;
    inFlight=true;
    fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok)throw Error('cart');return r.json()})
      .then(function(cart){
        // Save the actual cart when populated; otherwise use the selected product.
        presentForm((cart&&cart.item_count>0)?link(cart.items):source==='cart'?null:selected());
      })
      .catch(function(){
        // Storefront preview or a temporary cart endpoint issue must not make PDP clicks inert.
        presentForm(source==='cart'?null:selected());
      })
      .finally(function(){inFlight=false});
  }
  document.addEventListener('click',function(ev){
    var btn=ev.target.closest&&ev.target.closest('[data-elio-save-later]');
    if(!btn)return;
    ev.preventDefault();ev.stopPropagation();
    open(btn.getAttribute('data-elio-save-later'));
  },true);
  window.addEventListener('omnisendForms',function(ev){
    var d=(ev&&ev.detail)||{};
    var kind=d.type||d.eventName;
    var id=d.form&&String(d.form.id||'');
    if(id!==formID)return;
    if(kind==='view'){formSeen=true;return;}
    if(kind==='close'){pending=null;window.__ELIO_MANUAL_SAVE_INTENT__=false;return;}
    if(kind!=='submit'||!pending||didSubmit)return;
    var email=String((d.formValues&&d.formValues.emailField)||'').trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))return;
    didSubmit=true;
    var state=pending;pending=null;
    window.__ELIO_MANUAL_SAVE_INTENT__=false;
    try{if(window.omnisend&&typeof window.omnisend.identifyContact==='function')window.omnisend.identifyContact({email:email});}catch(err){}
    // Same custom event the EXISTING saved-cart automation already listens for.
    window.setTimeout(function(){
      window.omnisend=window.omnisend||[];
      window.omnisend.push(['track','elio_saved_cart',{origin:'api',properties:{savedCartUrl:state.url,itemCount:state.qty,lineItems:state.lineItems}}]);
    },550);
  });
  // Preview-only QA introspection: never sends events by itself.
  window.ElioSaveForLaterReview={open:open,selected:selected,cartSnapshot:link,version:'2026-11-01-fix-layout-click-feedback'};
})();